// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "main." + {"856":"e2287f64bc39633d02b9","894":"f46117626330b0f6b50d"}[chunkId] + ".js";
};